module.exports = __webpack_public_path__ + "img/walker-sitter-icon.07d8e832.png";